import Footer from 'components/footer/Footer';
import NavbarBottom from 'components/navbar/bottom/NavbarBottom';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import OfflineAlert from 'components/offline/OfflineAlert';
import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

const MainLayout = () => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <div className={'container'}>
        <NavbarVertical />
        <div className={'content'}>
          <NavbarTop />
          <OfflineAlert />
          <Outlet />
          <Footer />
        </div>
      </div>
      <NavbarBottom />
    </>
  );
};

export default MainLayout;
